import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Antd from "ant-design-vue";
import FormatCell from './components/FormatCell.vue';
import CommonShowMore from './components/CommonShowMore.vue';
import "./assets/style/theme.less";
import * as dayjs from 'dayjs'
import 'quill/dist/quill.snow.css';
import 'quill-mention/dist/quill.mention.min.css';

const viewApp = createApp(App);

viewApp.component('FormatCell', FormatCell);
// CommonShowMore
viewApp.component('CommonShowMore', CommonShowMore);

viewApp.use(Antd).use(store).use(router).mount("#app");

console.log = (function (log) {
  return process.env.VUE_APP_NO_CONSOLE == "1" ? function () { } : log;
})(console.log);
console.warn = (function (warn) {
  return process.env.VUE_APP_NO_CONSOLE == "1" ? function () { } : warn;
})(console.warn);

const formatDate = (value, format) => {
  if (value) {
    return dayjs(value).format(format);
  }
  return value;
}

const operationKubun = (value) => {
  switch (value) {
    case 'Create':
      return '新規作成';
    case 'Update':
      return '更新';
    case 'Delete':
      return '削除';
    default:
      break;
  }
}
const formatCell = (text, column) => {
  if (column.hasLink) {
    if (text === null) {
      return ''
    }
    const obj = JSON.parse(text);
    if (obj.link) {
      return `<a href="${obj.link}" target="${obj.link_is_blank ? '_blank' : ''}">${obj.title}</a>`;
    } else {
      return obj.title;
    }
  } else if (column.optionValueList) {
    const optionValueList = column.optionValueList
    const option = optionValueList.find(option => option.value === text)
    return option ? option.title : ''
  } else {
    return text === null ? '' : text;
  }
}

const formatJPY = (value, addMark) => {
  if (value === undefined || value === null) {
    return ''
  }
  if (value) {
    const formatter = new Intl.NumberFormat('ja-JP');
    let formatN = formatter.format(value);
    if (addMark && Math.abs(value) > 10000) {
      formatN = '￥' + formatN
    }
    return formatN
  }
  return value;
}

const formatBoolean = (value, l1, l2) => {
  if (typeof value === 'boolean') {
    return value ? l1 : l2;
  } else {
    return ''
  }
}

const stringToNumber = (value) => {
  return Number(value);
}

const fullwidthToHalfwidth = (str) => {
  return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
  });
}

const fullwidthToHalfwidthNumber = (str) => {
  str = str.replace(/[,|，]/g, "")
  return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
    return Number(String.fromCharCode(s.charCodeAt(0) - 0xFEE0));
  });
}

const getApLayoutContent = () => {
  return document.getElementById('apLayoutContent')
}

viewApp.config.globalProperties.$formatDate = formatDate;
viewApp.config.globalProperties.$operationKubun = operationKubun;
viewApp.config.globalProperties.$formatCell = formatCell;
viewApp.config.globalProperties.$formatJPY = formatJPY;
viewApp.config.globalProperties.$formatBoolean = formatBoolean;
viewApp.config.globalProperties.$stringToNumber = stringToNumber;
viewApp.config.globalProperties.$fullwidthToHalfwidth = fullwidthToHalfwidth;
viewApp.config.globalProperties.$fullwidthToHalfwidthNumber = fullwidthToHalfwidthNumber;
viewApp.config.globalProperties.$getApLayoutContent = getApLayoutContent;

viewApp.config.globalProperties.$dateYYYYMMDD = "YYYY/MM/DD"
viewApp.config.globalProperties.$dateYYYYMMDDFormat = ['YYYY/MM/DD', 'YYYY-MM-DD', 'YYYY/M/D', 'YYYY-M-D']

// rport和view暂时需要固定的格式
viewApp.config.globalProperties.$dateYYYYMMDDRV = "YYYY-MM-DD"

viewApp.config.globalProperties.$dateYYYYMM = "YYYY/MM"
viewApp.config.globalProperties.$dateYYYYMMFormat = ['YYYY/MM', 'YYYY-MM', 'YYYY-M', 'YYYY/M']
viewApp.config.globalProperties.$dateYYYYMM01 = "YYYY/MM/01"

viewApp.config.globalProperties.$dateYYYY = "YYYY"
viewApp.config.globalProperties.$dateYYYYFormat = ["YYYY"]

viewApp.config.globalProperties.$dateYYYYMMDDHHmm00 = "YYYY/MM/DD HH:mm:00"
viewApp.config.globalProperties.$dateYYYYMMDD000000 = "YYYY/MM/DD HH:mm:00"
viewApp.config.globalProperties.$dateYYYYMMDDHHmm = "YYYY/MM/DD HH:mm"
viewApp.config.globalProperties.$dateYYYYMMDDHHmmss = "YYYY/MM/DD HH:mm:ss"
viewApp.config.globalProperties.$dateYYYYMMDDHHmmFormat = ["YYYY/MM/DD HH:mm"]

window.VueGlobalProperties = viewApp.config.globalProperties

